import React from "react";
import PropTypes from 'prop-types';
import CheckboxOnly from './CheckboxOnly';
import { Icon, Typography } from '../../index';

const CheckboxSelect = React.forwardRef(({
    disabled = false,
    error = false,
    id,
    indeterminate = false,
    label,
    name,
    onChange,
    onClick,
    onKeyDown,
    required = false,
    role,
    size = "sm",
    value,
}, inputRef) => {

    const checkboxSelectClasses = [
        `bsw-checkbox__checkbox-select`,
        `bsw-checkbox__checkbox-select--size-${size}`,
        `${indeterminate ? 'bsw-checkbox__checkbox-select--indeterminate' : value ? 'bsw-checkbox__checkbox-select--selected' : 'bsw-checkbox__checkbox-select--inactive'}`,
        `${error ? 'bsw-checkbox__checkbox-select--error' : ''}`,
        `${disabled ? 'bsw-checkbox__checkbox-select--disabled' : ''}`
    ].join(' ');

    return (<label className={checkboxSelectClasses} role={role}>
        <div className="bsw-checkbox__checkbox-select-content-container">
            <CheckboxOnly
                disabled={disabled}
                error={error}
                id={id}
                indeterminate={indeterminate}
                //label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                onKeyDown={onKeyDown}
                inputRef={inputRef}
                required={required}
                size={size}
                value={value}
            />
            {label &&
                <div className="bsw-checkbox__checkbox-select-label">
                    <Typography
                        color={disabled ? "$color-secondary-a3" : ""}
                        type="body-02"
                    >
                        {label}
                    </Typography>
                </div>
            }
        </div>
    </label>)
})

CheckboxSelect.defaultProps = {
    disabled: false
}

CheckboxSelect.propTypes = {
    disabled: PropTypes.bool,
}
export default CheckboxSelect;